import onDomReady from './onDomReady';

onDomReady(() => {
	const el = document.querySelector('.homepage-slider');
	if (!el) return;
	const items_el = el.querySelector('.items');
	const items = Array.from(el.querySelectorAll('.slider-item'));
	const count = items.length;
	if (count === 0) return;

	const dot_controls = document.querySelector('.slider-dot-controls');
	const dots = dot_controls
		? Array.from(dot_controls.querySelectorAll('li'))
		: [];
	const fadeTargets = Array.from(
		document.querySelectorAll('.homepage-slider-title, .slider-scroll-down'),
	);
	const scrollDownButton = el.querySelector('.slider-scroll-down');

	let actual = 1;
	let interval = null;
	let sliderInView = true;

	showSlide(actual);

	function showSlide(i) {
		items.forEach(item => item.classList.remove('active'));
		dots.forEach(dot => dot.classList.remove('active'));
		items[i - 1]?.classList.add('active');
		dots[i - 1]?.classList.add('active');
	}

	function nextSlide() {
		actual = (actual % count) + 1;
		showSlide(actual);
	}

	function startAutoplay() {
		if (count <= 1 || interval !== null) return;
		interval = setInterval(nextSlide, 6000);
	}

	function stopAutoplay() {
		if (interval !== null) {
			clearInterval(interval);
			interval = null;
		}
	}

	if (count > 1) {
		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => {
				showSlide(index + 1);
				actual = index + 1;
				stopAutoplay();
				if (sliderInView) startAutoplay();
			});
		});
	}

	items.forEach(item => {
		const href = item.getAttribute('data-href');
		if (href) {
			item.addEventListener('click', () => {
				window.location.href = href;
			});
		}
	});

	const isWideViewport = () =>
		window.innerHeight < window.innerWidth || window.innerWidth > 1024;

	function updateParallax() {
		if (!sliderInView) return;

		const scrollPosition = window.scrollY;
		const windowHeight = window.innerHeight;
		const opacity = Math.min(Math.max((scrollPosition / windowHeight) * 1.4, 0), 1);
		const p = Math.round(-scrollPosition * 0.7);
		const offset = isWideViewport() ? p : -p;

		items_el.style.transform = `translate3d(0, ${offset}px, -1px)`;
		const fade = 1 - opacity;
		for (const target of fadeTargets) {
			target.style.opacity = fade;
		}
	}

	let ticking = false;
	window.addEventListener(
		'scroll',
		() => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					updateParallax();
					ticking = false;
				});
				ticking = true;
			}
		},
		{ passive: true },
	);

	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver(
			entries => {
				for (const entry of entries) {
					sliderInView = entry.isIntersecting;
					if (sliderInView) {
						items_el.style.display = 'block';
						updateParallax();
						startAutoplay();
					} else {
						items_el.style.display = 'none';
						stopAutoplay();
					}
				}
			},
			{ threshold: 0 },
		);
		observer.observe(el);
	} else {
		startAutoplay();
	}

	updateParallax();

	scrollDownButton?.addEventListener('click', e => {
		e.preventDefault();
		window.scrollTo({
			top: el.offsetHeight,
			behavior: 'smooth',
		});
	});
});
